import { useState } from "react";
import { Button, Card, useTheme, Radio } from "@material-ui/core";

import { REPAYMENT_METHOD_TYPE } from "../../../constants/applicationStatus";
import { useThemeStyles } from "../../../styles/themes";

const RepaymentCard = (props) => {
  const { selectedMethod, repaymentMethod, handleSelectMethod } = props;

  const classes = useThemeStyles();
  const theme = useTheme();

  const { title, isPreferred, icon, type, note } = repaymentMethod || {};

  const isChecked = selectedMethod === type;

  return (
    <Card variant="outlined" style={{ boxShadow: "none", borderRadius: "8px", borderColor: isChecked ? theme.colors.colorPrimary : theme.colors.colorPrimaryGrey200 }}>
      <Button onClick={() => handleSelectMethod(type)} style={{ padding: "16px" }} disableRipple>
        <div style={{ textTransform: "none" }}>
          {/* Top Section */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
              <span style={{ fontWeight: 700 }}>{title}</span>
              {isPreferred && (
                <span
                  style={{
                    fontWeight: 700,
                    padding: "2px 6px",
                    fontSize: "10px",
                    backgroundColor: theme.colors.colorPrimaryYellow,
                    borderRadius: "2px",
                    color: theme.palette.secondary.main,
                    textTransform: "uppercase"
                  }}
                >
                  Preferred
                </span>
              )}
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              {icon && <img src={icon.src} alt={icon.alt} style={{ height: "28px" }} />}
              <Radio
                checked={isChecked}
                icon={<img src="/images/radio-inactive-red.svg" alt="radio-inactive" />}
                checkedIcon={<img src="/images/radio-active-red.svg" alt="radio-active" />}
                name={`${type}-button`}
                style={{ padding: "0px" }}
              />
            </div>
          </div>

          <div className={`${classes.divider} divider`} style={{ margin: "16px 0px" }} />

          {/* Bottom Section */}
          <div style={{ display: "flex", gap: "8px" }}>
            <span style={{ fontWeight: 700, color: theme.colors.colorPrimaryDarker }}>NOTE:</span>
            <span className="small" style={{ textAlign: "left", fontSize: "15px", lineHeight: "20px" }}>{note}</span>
          </div>
        </div>
      </Button>
    </Card>
  );
};

const RepaymentMethodV2 = (props) => {
  const { handleSetupMandate, handleShowLinkBank } = props;
  const classes = useThemeStyles();
  const theme = useTheme();

  const [selectedMethod, setSelectedMethod] = useState(null);

  const repaymentMethods = [
    {
      title: "Debit Card",
      isPreferred: true,
      icon: {
        src: "/images/master-visa.png",
        alt: "mastercard-visa"
      },
      type: REPAYMENT_METHOD_TYPE.DEBIT_CARD,
      note: <><b>RM 20.00 (auto-refunded)</b> will be deducted to verify and link your debit card.</>
    },
    {
      title: "Bank Account",
      type: REPAYMENT_METHOD_TYPE.BANK_ACCOUNT,
      note: <><b>RM 1.00 (non-refundable)</b> will de deducted to verify and link your bank account.</>
    }
  ];

  const handleSelectMethod = (method) => setSelectedMethod(method);

  const handleContinue = () => {
    if (selectedMethod === REPAYMENT_METHOD_TYPE.DEBIT_CARD) {
      handleSetupMandate();
    }

    if (selectedMethod === REPAYMENT_METHOD_TYPE.BANK_ACCOUNT) {
      handleShowLinkBank();
    }
  };

  return (
    <>
      <div>
        <p className={`${classes.title} title`}>Set Repayment Method</p>
        <p
          className={`${classes.subtitle} sub-title-v2`}
          style={{ color: theme.colors.colorPrimaryDarker }}
        >
          Your repayments will be auto-deducted based on your selected method.
        </p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {repaymentMethods.map((repaymentMethod) => {
          return <RepaymentCard key={repaymentMethod.type} selectedMethod={selectedMethod} repaymentMethod={repaymentMethod} handleSelectMethod={handleSelectMethod} />;
        })}

        <Button className={`${classes.btnContained} btn-next`} variant="contained" color="primary" onClick={handleContinue} style={{ marginTop: "24px" }}>
          Continue
        </Button>
      </div>
    </>
  );
};

export default RepaymentMethodV2;
